require("./../../public/javascripts/modaal");

export function init_cart() {
    //カート内全削除
    $(document).on("click", ".js-cart-delete", function () {
        operate_cart_items("delete_cart");
    });

    $("input.js-not_write_name, input.js-accept_write_name").click(function () {
        $("#js-no_selected_product_option").hide();
        $("#js-selected_product_option").show();
        if ($(this).val() == "not_write_name") {
            $("#js-product_option").hide();
        } else {
            $("#js-product_option").show();
        }
    });

    // 数量変更時の再計算処理
    // 「数量」ボタンで数量が変更された際は、Javascriptで判定を行い価格を切り替える
    $(document).on("input", ".cart_amount_field", function () {
        var target = $(this);
        // 現在入力された数量を整数として取得（NaNの場合は0）
        var currentAmount = parseInt(target.val(), 10) || 0;
        // 数量変更時にリアルタイムで割引案内を更新（DBアクセスなし）
        updateDiscountGuidance(target, currentAmount);

        // HTML全置換でDOM要素が破棄されても、タイマーを確実にキャンセルできるようにクロージャ変数で管理
        var catalog_item_cd = target.attr("data-catalog-item-cd");
        if (debounceTimers[catalog_item_cd]) {
            clearTimeout(debounceTimers[catalog_item_cd]);
        }

        // イベント発生時（入力直後）の値を保持する
        var amount = target.val();

        // ユーザーの最新入力値をクロージャ変数に即座に保存
        latestInputValues[catalog_item_cd] = amount;

        debounceTimers[catalog_item_cd] = setTimeout(function () {
            // タイマー発火後はタイマーIDを削除
            delete debounceTimers[catalog_item_cd];

            if (amount < 1) {
                alert("数量には1以上を指定してください");
                return;
            }

            var cart_item_data = {
                catalog_item_cd: catalog_item_cd,
                amount: amount,
            };

            // 通信中の場合は送信を予約して終わる
            if (isOperating) {
                pendingRequest = cart_item_data;
                return;
            }

            // 通信中でなければ直ちに送信
            operate_cart_items("update_cart_detail", cart_item_data);
        }, 400);
    });

    // カートに戻す
    $(document).on("click", ".js-cart-pending-item-to-move-cart", function () {
        var pending_item_id = $(this).attr("data-cart-pending-item-id");
        var pending_item_data = {
            id: pending_item_id,
        };

        operate_cart_items("move_cart_pending_item", pending_item_data);
    });

    // あとで買うに追加
    $(document).on(
        "click",
        ".js-cart-detail-move-to-cart-pending-item",
        function () {
            var cart_detail_id = $(this).attr("data-cart-detail-id");
            var cart_item_data = {
                id: cart_detail_id,
            };
            operate_cart_items("move_cart_detail", cart_item_data);
        },
    );

    // あとで買う商品削除モーダルを開く
    $(document).on(
        "click",
        ".js-open-cart-pending-item-delete-modal",
        function () {
            window.cart_pending_item_id = $(this).attr(
                "data-cart-pending-item-id",
            );
        },
    );

    // 商品削除モーダルを開く
    $(document).on("click", ".js-open-cart-detail-delete-modal", function () {
        window.cart_detail_id = $(this).attr("data-cart-detail-id");
        window.embroidery_pattern_id = $(this).attr(
            "data-embroidery-pattern-id",
        );
    });

    // カート内商品削除
    $(document).on("click", ".js-cart-detail-delete", function () {
        var cart_detail_id = window.cart_detail_id;
        var embroidery_pattern_id = window.embroidery_pattern_id;
        var cart_item_data = {
            id: cart_detail_id,
        };

        if (embroidery_pattern_id) {
            // 刺繍パターンの削除時、刺繍パターン数分の商品数を再計算する
            cart_item_data.embroidery_pattern_id = embroidery_pattern_id;
            operate_cart_items(
                "delete_embroidery_pattern_cart_detail",
                cart_item_data,
            );
        } else {
            operate_cart_items("delete_cart_detail", cart_item_data);
        }
    });

    // あとで買う削除
    $(document).on("click", ".js-cart-pending-item-delete", function () {
        var pending_item_id = window.cart_pending_item_id;
        var pending_item_data = {
            id: pending_item_id,
        };

        operate_cart_items("delete_cart_pending_item", pending_item_data);
    });

    // 購入手続きへに遷移
    $(document).on("click", ".js-to-order-setting", function () {
        $("form").submit();
    });

    // 引数に指定されたリクエストを実施後に画面に表示されている内容を更新
    var isOperating = false;
    // HTML全置換でDOMが破棄されても値が失われないようにするクロージャ変数
    var pendingRequest = null;
    // HTML全置換でDOM要素が破棄されてもタイマーを確実にキャンセルできるようにするクロージャ変数
    var debounceTimers = {};
    // ユーザーの最新入力値を catalog_item_cd をキーとして常に追跡するクロージャ変数
    var latestInputValues = {};
    // タイムアウトフォールバック中の同じカート状態で、非同期再取得を重複起動しない
    var refreshingCartPriceTokens = {};

    function replaceCartItemsHtml(data) {
        $("#js-reload-cart-items").html(data);
        initToggle();
        build_modal();
        restoreLatestInputValues();
        refreshCartPricesIfNeeded();
    }

    function restoreLatestInputValues() {
        // HTML全置換後、latestInputValues に保持されている最新ユーザー入力値で入力フィールドと割引案内を即時復元する
        var restoredCds = {};
        var hasRestoredFields = false;
        Object.keys(latestInputValues).forEach(function (cd) {
            var field = $('.cart_amount_field[data-catalog-item-cd="' + cd + '"]');
            if (field.length) {
                // 数量フィールドを最新ユーザー入力値で上書き
                field.val(latestInputValues[cd]);
                // フォーカスを復元してスピナー（上下ボタン）の操作性を維持する
                field.focus();
                // 最新値ベースで割引案内・単価・小計・合計を再計算（DBアクセスなし）
                updateDiscountGuidance(
                    field,
                    parseInt(latestInputValues[cd], 10) || 0,
                );
                restoredCds[cd] = true;
                hasRestoredFields = true;
            }
        });

        // 復元対象以外の商品は通常通り割引案内を更新
        if (hasRestoredFields) {
            $(".cart_amount_field").each(function () {
                var target = $(this);
                var cd = target.attr("data-catalog-item-cd");
                if (restoredCds[cd]) {
                    return; // 復元済みの商品はスキップ
                }
                var currentAmount = parseInt(target.val(), 10) || 0;
                updateDiscountGuidance(target, currentAmount);
            });
        } else {
            refreshDiscountGuidance();
        }
    }

    function operate_cart_items(action, data = {}) {
        if (isOperating) return;
        isOperating = true;

        // 通信中の操作制御
        $("#js-reload-cart-items").css({ "pointer-events": "none" });

        var url = `${location.pathname}/${action}`;
        $.ajax({
            type: "POST",
            url: url,
            data: data,
        })
            .done(function (data) {
                replaceCartItemsHtml(data);
                reload_header_cart_items();
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                alert("正しく反映されませんでした。画面を更新してください。");
            })
            .always(function () {
                isOperating = false;
                $("#js-reload-cart-items").css({ "pointer-events": "" });

                // 保留されていたリクエスト（連打時の最後の入力値）があれば、それを処理する
                // ※ クロージャ変数から取得するため、HTML全置換の影響を受けない
                if (pendingRequest) {
                    var pendingData = pendingRequest;
                    pendingRequest = null;
                    // pending対象のdebounceタイマーをクリア（二重送信防止）
                    // HTML全置換をまたいで旧タイマーが発火し、同じ値を再送信するのを防ぐ
                    if (debounceTimers[pendingData.catalog_item_cd]) {
                        clearTimeout(
                            debounceTimers[pendingData.catalog_item_cd],
                        );
                        delete debounceTimers[pendingData.catalog_item_cd];
                    }
                    operate_cart_items("update_cart_detail", pendingData);
                } else {
                    // 全リクエスト完了（pendingなし）→ latestInputValues をクリーンアップ
                    // debounceタイマーが残っている商品は入力途中なので維持する
                    Object.keys(latestInputValues).forEach(function (cd) {
                        if (!debounceTimers[cd]) {
                            delete latestInputValues[cd];
                        }
                    });

                    refreshCartPricesIfNeeded();
                }
            });
    }

    // ヘッダーの買い物カゴを更新
    function reload_header_cart_items() {
        var url = "/show_my_cart";

        $.ajax({
            type: "GET",
            url: url,
        })
            .done(function (data) {
                $(".js-reload-cart-items").html(data);
            })
            .fail(function (data) {
                alert("正しく反映されませんでした。画面を更新してください。");
            });
    }

    function currentCartPriceFallbackMeta() {
        // タイムアウトフォールバック表示中かを判定するためのメタ情報を取得する
        return $("#js-reload-cart-items")
            .find('[data-cart-price-fallback-meta="true"]')
            .first();
    }

    function currentCartPriceFallbackToken() {
        var meta = currentCartPriceFallbackMeta();
        if (!meta.length) return null;

        // 非同期再取得の開始時点と現在表示中のカート更新日時を比較する
        return meta.attr("data-cart-updated-at") || null;
    }

    function hasPendingCartPriceRefreshOperations() {
        // 入力中や送信中の操作がある場合は、古い再取得結果で画面を上書きしない
        return (
            Object.keys(latestInputValues).length > 0 ||
            Object.keys(debounceTimers).length > 0 ||
            isOperating ||
            !!pendingRequest
        );
    }

    function refreshCartPricesIfNeeded() {
        // 保存済み単価で描画したカートを、統一価格の再取得結果へ差し替える
        var meta = currentCartPriceFallbackMeta();
        if (!meta.length) return;
        if (meta.attr("data-fallback-reason") !== "timeout") return;

        var cartUpdatedAt = meta.attr("data-cart-updated-at");
        var refreshUrl = meta.attr("data-refresh-prices-url");
        // 更新日時や再取得先がない場合、または同じカート状態で取得中の場合は起動しない
        if (!cartUpdatedAt || !refreshUrl || refreshingCartPriceTokens[cartUpdatedAt]) {
            return;
        }

        refreshingCartPriceTokens[cartUpdatedAt] = true;

        $.ajax({
            type: "GET",
            url: refreshUrl,
        })
            .done(function (data) {
                // 空レスポンス、古いカート状態、未反映操作ありの場合は現在の表示を維持する
                if (!data) return;
                if (currentCartPriceFallbackToken() !== cartUpdatedAt) return;
                if (hasPendingCartPriceRefreshOperations()) return;

                replaceCartItemsHtml(data);
            })
            .fail(function () {
                // 非同期再取得の失敗では現在の表示を維持し、ユーザーには通知しない
            })
            .always(function () {
                // 失敗や破棄の後も、同じカート状態で再試行できるようにする
                delete refreshingCartPriceTokens[cartUpdatedAt];
            });
    }

    // ----------------------------------------
    // モーダル
    // ----------------------------------------
    $(function () {
        build_modal();
    });

    function build_modal() {
        if ($(".js-cart-modal").length) {
            var options = {
                overlay_opacity: "0.5",
                custom_class: "modal-wrap",
                hide_close: false,
                start_open: false,
            };

            $(".js-cart-modal").modaal(options);
        }
    }

    // 割引案内の更新処理
    var GUIDANCE_THRESHOLD = 0.8;

    // 画面内の全カート商品に対して割引案内を更新する関数
    // カート内容変更後（削除、あとで買う、カゴに戻す）に呼び出される
    function refreshDiscountGuidance() {
        // カート内の全商品の数量フィールドをループ
        $(".cart_amount_field").each(function () {
            var target = $(this);
            var currentAmount = parseInt(target.val(), 10) || 0;
            // 各商品の割引案内を更新
            updateDiscountGuidance(target, currentAmount);
        });
    }

    // 数量入力などの要素から、割引情報を持つ「商品行」要素まで遡って取得
    function findCartItemRow(target) {
        return target.closest("[data-discount-info]");
    }

    // 商品行から、合計金額を再計算するための「カート全体のコンテナ」を探す
    function findCartItemsContainer(row) {
        if (!row || !row.length) return $();
        var table = row.closest("table");
        if (table.length) return table;
        var container = row.closest(".cart-product");
        if (container.length) return container;
        return row.closest("#js-reload-cart-items");
    }

    // 組合せ単価のグループコードで、同じグループに属する商品行だけを集める
    function findGroupRows(container, groupCd) {
        if (!groupCd) return $();
        if (container && container.length) {
            return container.find(
                '[data-quantity-sale-group-cd="' +
                    groupCd +
                    '"][data-discount-info]',
            );
        }
        return $(
            '[data-quantity-sale-group-cd="' +
                groupCd +
                '"][data-discount-info]',
        );
    }

    // data属性から受け取った価格情報を、比較しやすい数値オブジェクトにそろえる
    function normalizePrice(priceInfo) {
        if (!priceInfo) return null;

        var taxIncluded = parseInt(priceInfo.taxIncluded, 10);
        var taxExcluded = parseInt(priceInfo.taxExcluded, 10);
        if (isNaN(taxIncluded) || isNaN(taxExcluded)) return null;

        return {
            taxIncluded: taxIncluded,
            taxExcluded: taxExcluded,
        };
    }

    // 現在表示している単価を優先し、未設定時だけ現在の表示内容から単価を復元
    function basePriceForRow(row, discountInfo) {
        var basePrice = normalizePrice(discountInfo && discountInfo.basePrice);
        if (basePrice) return basePrice;

        return {
            taxIncluded: parsePriceText(row.find(".js-display-price").text()),
            taxExcluded: parsePriceText(
                row.find(".js-display-price-notax").text(),
            ),
        };
    }

    // 候補単価が基準単価より安い時だけ採用し、そうでなければ基準単価を維持する
    function cheaperPrice(basePrice, candidatePrice) {
        if (!basePrice) return candidatePrice;
        if (!candidatePrice) return basePrice;

        return candidatePrice.taxIncluded < basePrice.taxIncluded
            ? candidatePrice
            : basePrice;
    }

    // 割引単価が実際に安くなる時だけ、その単価を画面反映用として返す
    function effectiveDiscountPrice(basePrice, discountInfo) {
        return cheaperPrice(
            basePrice,
            normalizePrice(discountInfo && discountInfo.discountPrice),
        );
    }

    // 「割引あり」と見なすのは、割引単価が基準単価を下回るケースだけ
    function hasEffectiveDiscount(basePrice, discountPrice) {
        if (!basePrice || !discountPrice) return false;

        return discountPrice.taxIncluded < basePrice.taxIncluded;
    }

    // 案内文に出す 1 点あたり値引き額も、現在表示中の単価との差額で求める
    function discountPerItem(basePrice, discountPrice) {
        if (!hasEffectiveDiscount(basePrice, discountPrice)) return 0;

        return basePrice.taxIncluded - discountPrice.taxIncluded;
    }

    // 税込・税抜の表示を同時に差し替える
    function updateDisplayedPrice(row, priceInfo) {
        if (!priceInfo) return;

        row.find(".js-display-price").text(formatPrice(priceInfo.taxIncluded));
        row.find(".js-display-price-notax").text(
            formatPrice(priceInfo.taxExcluded),
        );
    }

    // 複数段階の割引情報から、現在の数量に適用される段階を見つける
    // stages は boundary 昇順でソート済みであることを前提とする
    function findApplicableStage(stages, currentAmount) {
        if (!stages || stages.length === 0) return null;
        var applicable = null;
        for (var i = stages.length - 1; i >= 0; i--) {
            if (currentAmount >= stages[i].boundary) {
                applicable = stages[i];
                break;
            }
        }
        return applicable;
    }

    // 複数段階の割引情報から、まだ到達していない次の段階を見つける
    function findNextStage(stages, currentAmount) {
        if (!stages || stages.length === 0) return null;
        for (var j = 0; j < stages.length; j++) {
            if (currentAmount < stages[j].boundary) {
                return stages[j];
            }
        }
        return null;
    }

    // 数量変更時に呼び出される割引案内更新処理（DBにアクセスはしない）
    function updateDiscountGuidance(target, newAmount) {
        var row = findCartItemRow(target);
        if (!row.length) return;
        // HTMLにセットされた割引情報（data属性）を取得
        var discountInfoStr = row.attr("data-discount-info");
        if (!discountInfoStr) return;

        var discountInfo;
        try {
            discountInfo = JSON.parse(discountInfoStr);
        } catch (e) {
            return;
        }

        if (!discountInfo || Object.keys(discountInfo).length === 0) {
            var currentDisplayedUnitPrice = parsePriceText(
                row.find(".js-display-price").text(),
            );
            updateRowSubtotal(row, currentDisplayedUnitPrice);
            updateCartTotal(findCartItemsContainer(row));
            return;
        }

        if (discountInfo.type === "quantity") {
            // 数量単価商品（設定区分12）
            updateQuantityDiscount(row, discountInfo, newAmount);
        } else if (discountInfo.type === "combination") {
            // 組合わせ単価商品（設定区分13）
            updateCombinationDiscount(row, discountInfo);
        }
    }

    // 数量単価商品の処理（複数段階対応）
    function updateQuantityDiscount(row, discountInfo, newAmount) {
        var guidanceElement = row.find(".js-discount-guidance-text");
        var guidanceContainer = row.find(".js-discount-guidance");
        var basePrice = basePriceForRow(row, discountInfo);
        var stages = discountInfo.stages;

        if (stages && stages.length > 0) {
            // 複数段階: 現在の数量で適用される段階を探す
            var applicableStage = findApplicableStage(stages, newAmount);

            var displayPrice;
            if (applicableStage) {
                var stagePrice = normalizePrice(applicableStage.discountPrice);
                displayPrice = cheaperPrice(basePrice, stagePrice) || basePrice;
            } else {
                displayPrice = basePrice;
            }

            if (!displayPrice) return;

            updateDisplayedPrice(row, displayPrice);
            updateRowSubtotal(row, displayPrice.taxIncluded);
            updateCartTotal(findCartItemsContainer(row));

            // 次に到達可能な段階を見つけて案内表示
            var nextStage = findNextStage(stages, newAmount);

            if (nextStage) {
                var nextStagePrice = normalizePrice(nextStage.discountPrice);
                var hasNextDiscount = hasEffectiveDiscount(
                    basePrice,
                    nextStagePrice,
                );
                var shouldShowGuidance =
                    hasNextDiscount &&
                    newAmount >= nextStage.boundary * GUIDANCE_THRESHOLD &&
                    newAmount < nextStage.boundary;

                if (shouldShowGuidance) {
                    var remaining = nextStage.boundary - newAmount;
                    var perItemDiscount = discountPerItem(
                        basePrice,
                        nextStagePrice,
                    );
                    guidanceElement.text(
                        "あと" +
                            remaining +
                            "点で数量割引 1点あたり-" +
                            formatPrice(perItemDiscount),
                    );
                    guidanceContainer.show();
                } else {
                    guidanceContainer.hide();
                }
            } else {
                // 全段階到達済み → 案内非表示
                guidanceContainer.hide();
            }
        } else {
            // 単一段階処理
            var boundary = discountInfo.boundary;
            var discountedPrice = effectiveDiscountPrice(
                basePrice,
                discountInfo,
            );
            var hasDiscount = hasEffectiveDiscount(basePrice, discountedPrice);

            var useDiscountPrice = newAmount >= boundary;
            var displayPriceSingle = useDiscountPrice
                ? discountedPrice
                : basePrice;
            if (!displayPriceSingle) return;

            updateDisplayedPrice(row, displayPriceSingle);
            updateRowSubtotal(row, displayPriceSingle.taxIncluded);
            updateCartTotal(findCartItemsContainer(row));

            var shouldShowGuidanceSingle =
                hasDiscount &&
                newAmount >= boundary * GUIDANCE_THRESHOLD &&
                newAmount < boundary;

            if (shouldShowGuidanceSingle) {
                var remainingSingle = boundary - newAmount;
                var perItemDiscountSingle = discountPerItem(
                    basePrice,
                    discountedPrice,
                );
                guidanceElement.text(
                    "あと" +
                        remainingSingle +
                        "点で数量割引 1点あたり-" +
                        formatPrice(perItemDiscountSingle),
                );
                guidanceContainer.show();
            } else {
                guidanceContainer.hide();
            }
        }
    }

    // 組み合わせ単価商品の表示単価と案内表示を更新
    function updateCombinationDiscount(row, discountInfo) {
        var groupCd =
            discountInfo.groupCd || row.attr("data-quantity-sale-group-cd");
        if (!groupCd) return;
        // カート全体コンテナを取得
        var container = findCartItemsContainer(row);
        // 同じ組み合わせグループの商品行を集める
        var groupRows = findGroupRows(container, groupCd);
        // グループ全体の数量合計を計算
        var groupTotalAmount = calculateGroupTotalAmount(groupRows);
        // 複数段階情報を取得
        var stages = discountInfo.stages;

        // 複数段階がある場合の適用段階判定
        var applicableStage =
            stages && stages.length > 0
                ? findApplicableStage(stages, groupTotalAmount)
                : null;

        // 従来のboundary判定
        var boundary = parseInt(discountInfo.boundary, 10) || 0;
        var useDiscountPrice =
            stages && stages.length > 0
                ? applicableStage !== null
                : groupTotalAmount >= boundary;

        // 同じグループの全商品に対して価格を更新
        groupRows.each(function () {
            // 現在処理中の商品行を取得
            var groupRow = $(this);
            // 行ごとの割引情報 JSON を取得
            var rowDiscountInfoStr = groupRow.attr("data-discount-info");
            // 割引情報がない行はスキップ
            if (!rowDiscountInfoStr) return;

            var rowDiscountInfo;
            try {
                rowDiscountInfo = JSON.parse(rowDiscountInfoStr);
            } catch (e) {
                return;
            }

            var guidanceContainer = groupRow.find(".js-discount-guidance");
            // 行ごとの現在表示している単価を取得
            var basePrice = basePriceForRow(groupRow, rowDiscountInfo);

            var displayPrice;
            if (useDiscountPrice) {
                // 行ごとの stages から適用段階を探す
                var rowStages = rowDiscountInfo.stages;
                var rowApplicableStage =
                    rowStages && rowStages.length > 0
                        ? findApplicableStage(rowStages, groupTotalAmount)
                        : null;

                if (rowApplicableStage) {
                    var stagePrice = normalizePrice(
                        rowApplicableStage.discountPrice,
                    );
                    displayPrice =
                        cheaperPrice(basePrice, stagePrice) || basePrice;
                } else {
                    var discountedPrice = effectiveDiscountPrice(
                        basePrice,
                        rowDiscountInfo,
                    );
                    displayPrice = discountedPrice || basePrice;
                }
            } else {
                displayPrice = basePrice;
            }

            if (!displayPrice) return;

            // 行単価と行小計を更新
            updateDisplayedPrice(groupRow, displayPrice);
            updateRowSubtotal(groupRow, displayPrice.taxIncluded);

            // 次の段階に対する案内表示判定
            var shouldShowGuidance = false;
            var guidanceRemaining = 0;
            var guidancePerItem = 0;
            if (stages && stages.length > 0) {
                var nextStage = findNextStage(stages, groupTotalAmount);
                if (nextStage) {
                    var nextStagePrice = normalizePrice(
                        nextStage.discountPrice,
                    );
                    // 複数段階がなければ従来の単一段階判定を使う
                    var hasNextDiscount = hasEffectiveDiscount(
                        basePrice,
                        nextStagePrice,
                    );
                    shouldShowGuidance =
                        hasNextDiscount &&
                        groupTotalAmount >=
                            nextStage.boundary * GUIDANCE_THRESHOLD &&
                        groupTotalAmount < nextStage.boundary;
                    if (shouldShowGuidance) {
                        guidanceRemaining = nextStage.boundary - groupTotalAmount;
                        guidancePerItem = discountPerItem(basePrice, nextStagePrice);
                    }
                }
            } else {
                var rowDiscountedPrice = effectiveDiscountPrice(
                    basePrice,
                    rowDiscountInfo,
                );
                var hasDiscount = hasEffectiveDiscount(
                    basePrice,
                    rowDiscountedPrice,
                );
                shouldShowGuidance =
                    hasDiscount &&
                    groupTotalAmount >= boundary * GUIDANCE_THRESHOLD &&
                    groupTotalAmount < boundary;
                if (shouldShowGuidance) {
                    guidanceRemaining = boundary - groupTotalAmount;
                    guidancePerItem = discountPerItem(basePrice, rowDiscountedPrice);
                }
            }

            // 判定結果に応じて案内の表示・非表示とテキストを切り替える
            if (shouldShowGuidance) {
                var textEl = groupRow.find(".js-discount-guidance-text");
                if (textEl.length && guidanceRemaining > 0 && guidancePerItem > 0) {
                    textEl.text(
                        "対象商品からあと" +
                            guidanceRemaining +
                            "点で数量割引 1点あたり-" +
                            formatPrice(guidancePerItem),
                    );
                }
                guidanceContainer.show();
            } else {
                guidanceContainer.hide();
            }
        });

        // グループ更新後にカート全体合計を再計算
        updateCartTotal(container);
    }

    // 組合せ商品グループコードごとにグルーピングし、グループ内の商品の数量をカウント
    function calculateGroupTotalAmount(groupRows) {
        var total = 0;
        if (!groupRows || !groupRows.length) return total;
        // 同じdata-quantity-sale-group-cd属性を持つ全行を検索
        groupRows.each(function () {
            var amountField = $(this).find(".cart_amount_field");
            if (amountField.length) {
                total += parseInt(amountField.val(), 10) || 0;
            }
        });
        return total;
    }

    // 価格テキストから数値を抽出（「1,234円」→ 1234）
    function parsePriceText(text) {
        if (!text) return 0;
        return parseInt(text.replace(/[^\d]/g, ""), 10) || 0;
    }

    // 入力フィールドまたは表示テキストから数量を取得
    function getRowAmount(row) {
        var amountField = row.find(".cart_amount_field");
        if (amountField.length) {
            return parseInt(amountField.val(), 10) || 0;
        }
        var readonlyField = row.find(".cart-table__num");
        if (readonlyField.length) {
            return parseInt(readonlyField.val(), 10) || 0;
        }
        return parseInt(row.find(".cart-table__data--num").text(), 10) || 0;
    }

    // 小計を更新（単価 × 数量）
    function updateRowSubtotal(row, unitPrice) {
        var amount = getRowAmount(row);
        var subtotal = unitPrice * amount;
        var subtotalElement = row.find(".js-row-subtotal");
        if (subtotalElement.length) {
            subtotalElement.text(formatPrice(subtotal));
        } else {
            row.find(".cart-table__data--subtotal").text(formatPrice(subtotal));
        }
    }

    // カート全体の合計金額を更新
    function updateCartTotal(container) {
        if (!container || !container.length) return;
        var total = 0;
        // 各商品行の単価×数量を合計
        container.find("[data-discount-info]").each(function () {
            var row = $(this);
            var unitPrice = parsePriceText(
                row.find(".js-display-price").text(),
            );
            var amount = getRowAmount(row);
            total += unitPrice * amount;
        });
        // 合計表示を更新
        var totalElement = container.find(".js-cart-total");
        if (totalElement.length) {
            totalElement.text(formatPrice(total));
        } else {
            container.find(".cart-table__data--total").text(formatPrice(total));
        }
    }

    // 金額を日本円形式でフォーマット（1234 → "1,234円"）
    function formatPrice(price) {
        return price.toLocaleString("ja-JP") + "円";
    }

    refreshCartPricesIfNeeded();

    // 画面読み込み時に初回の割引案内表示を実行
    refreshDiscountGuidance();

    $(document).on("click", ".js-cart-modal-close", function () {
        if ($(".js-cart-modal").length) {
            $(".js-cart-modal").modaal("close");
        }
    });
}
